import store from '@/store';
import router from '@/router';
import toast from '@/composables/toast';
import { autoSpinner } from './spinner';

// 401 처리 중인지 플래그 (중복 리다이렉트 방지)
let isRedirectingToLogin = false;

// 대기 중인 요청 취소 함수들
let pendingRequests = [];

// 기본 401 메시지
const DEFAULT_401_MESSAGE = '세션이 만료되었습니다. 다시 로그인해주세요.';

/**
 * 요청 취소 함수 등록
 * @param {Function} cancelFn - axios CancelToken의 cancel 함수
 */
export const addPendingRequest = (cancelFn) => {
  pendingRequests.push(cancelFn);
};

/**
 * 완료된 요청의 취소 함수 제거
 * @param {Function} cancelFn - 제거할 cancel 함수
 */
export const removePendingRequest = (cancelFn) => {
  const index = pendingRequests.indexOf(cancelFn);
  if (index > -1) {
    pendingRequests.splice(index, 1);
  }
};

/**
 * 401 발생 시 처리 - 재로그인 필요
 * 모든 대기 요청을 취소하고 로그인 페이지로 리다이렉트
 * @param {string} message - 서버에서 전달한 에러 메시지 (선택)
 */
export const handle401Error = (message) => {
  if (isRedirectingToLogin) return;

  isRedirectingToLogin = true;

  // toast 메시지 표시 (한 번만)
  toast.error(DEFAULT_401_MESSAGE);

  // 모든 대기 중인 요청 취소
  pendingRequests.forEach((cancel) => cancel('Token expired'));
  pendingRequests = [];

  // 스피너 강제 종료
  autoSpinner.forceStop();

  // 세션 정리
  sessionStorage.removeItem('token');
  store.commit('authority/logout');

  // 로그인 페이지로 이동
  router
    .push({
      path: '/login',
      query: { expired: 'true' },
    })
    .finally(() => {
      isRedirectingToLogin = false;
    });
};

/**
 * 401 처리 중인지 확인
 * @returns {boolean}
 */
export const isHandling401 = () => isRedirectingToLogin;
